import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html'
})
export class ModalInfoComponent {
  @Input() descriptions: { title: string; text: string }[] = [];

  constructor(public activeModal: NgbActiveModal) {}
}